import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import FormControl from 'src/app/components/FormControl/FormControl';
import PasswordMask from 'src/app/components/PasswordMask';
import {
  accountFormPasswordBlur,
  accountFormPasswordChange,
  accountFormPasswordFocus,
  accountFormPasswordSet,
  accountFormPasswordSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormPassword';
import inputPropTypes from 'src/app/propTypes/input';


class AccountFormPasswordContainer extends React.PureComponent {
  onBlur = ({ target }) => {
    const { dispatch, markedAsWrong } = this.props;
    const { validationMessage } = target;

    dispatch(accountFormPasswordBlur(markedAsWrong, validationMessage));
    dispatch(accountFormPasswordSetValidationMessage(validationMessage));
  };

  onChange = ({ target }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { value, validationMessage } = target;

    dispatch(accountFormPasswordSet(target.value));

    dispatch(accountFormPasswordChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(accountFormPasswordFocus());
  };

  render() {
    const { onBlur, onChange, onFocus } = this;
    const { value, validationMessage, markedAsWrong, focus, apiError, inputRef, sending } = this.props;
    const hint = `
      Hasło musi zawierać min. 6 znaków. Żeby hasło było silne, użyj przynajmniej jednej cyfry i wielkiej litery.
    `;
    return (
      <React.Fragment>
        <FormControl disabled={ sending }
                     label="Hasło"
                     hint={ hint }
                     {
                       ...{
                         value,
                         validationMessage,
                         markedAsWrong,
                         focus,
                         apiError
                       }
                     }
        >
          <PasswordMask data-test="input-password" { ...{ value, onChange, onFocus, onBlur, inputRef } }/>
        </FormControl>
      </React.Fragment>
    );
  }
}

AccountFormPasswordContainer.propTypes = {
  ...inputPropTypes,
  sending: PropTypes.bool.isRequired,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};

const mapStateToProps = (store) => ({
  ...store.accountFormPasswordReducer,
  sending: store.accountFormReducer.sending
});

export default connect(mapStateToProps)(AccountFormPasswordContainer);
